(function () {
    /**
     * Included on App.js
     */
    angular.module('harriApp.rejectionTemplates', []);
})();
